<template>
    <section>
        <video-poup :videoData="videoData" />
        <div class="row">
            <div class="col-sm-3 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" class="col-sm-9 right-colm">
                <div class="material-box bg-white p-2">
                    <div class="row content-row ">
                        <div class="col-md-12 top-title">
                            <h3>Skill Sets - {{ skill.SkillSetName }} </h3>
                        </div>
                        <div class="col-md-12 ">
                            <div class="content-colm row">
                                <!-- <div class="col-md-12">
                                    <div class="content-colm row">
                                        <div class="col-md-12">
                                            <div class="material-list video">
                                                <h4>Coaching Calls (schedule)</h4>
                                                <div v-for="(item, index) in nextUrl" :key="index">
                                                    <li @click.prevent="openCalendlyPopup(item.attributes.url)"
                                                        class="completed"><span>{{
                                                            item.attributes.name }}</span>
                                                        <span class="events_schedule"
                                                            v-for="(data, index1) in eventData" :key="index1">
                                                            <span v-if="data.events_id === item.id">Completed
                                                            </span>
                                                        </span>
                                                    </li>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> -->
                                <div class="col-md-12">
                                    <div class="material-list video">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(document, i) in material.documents" :key="i">
                                                        <span v-if="i >= 7">
                                                            <a href="javascript:;" :id="`popover-target-document${i}`">
                                                                {{ document.DocName }}
                                                            </a>
                                                            <b-popover :target="`popover-target-document${i}`"
                                                                triggers="focus" placement="right">
                                                                <div class="btn-group" role="group">
                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url + 'storage/documents/' + document.DocLocation}`"
                                                                        type="button" target="_blank"
                                                                        class="btn yellow-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a>
                                                                    <a @click.prevent="downloadFile(document.DocLocation, document.DocName)"
                                                                        class="btn blue-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </b-popover>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="material-list video">
                                        <h4>Documents</h4>
                                        <div class="row">

                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(document, i) in material.documents" :key="i">
                                                        <span v-if="i < 7">
                                                            <a href="javascript:;" :id="`popover-target-document${i}`">
                                                                {{ document.DocName }}
                                                            </a>
                                                            <b-popover :target="`popover-target-document${i}`"
                                                                triggers="focus" placement="right">
                                                                <div class="btn-group" role="group">
                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url + 'storage/documents/' + document.DocLocation}`"
                                                                        type="button" target="_blank"
                                                                        class="btn yellow-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a>
                                                                    <a @click.prevent="downloadFile(document.DocLocation, document.DocName)"
                                                                        class="btn blue-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </b-popover>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(document, i) in material.documents" :key="i">
                                                        <span v-if="i >= 7">
                                                            <a href="javascript:;" :id="`popover-target-document${i}`">
                                                                {{ document.DocName }}
                                                            </a>
                                                            <b-popover :target="`popover-target-document${i}`"
                                                                triggers="focus" placement="right">
                                                                <div class="btn-group" role="group">
                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url + 'storage/documents/' + document.DocLocation}`"
                                                                        type="button" target="_blank"
                                                                        class="btn yellow-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a>
                                                                    <a @click.prevent="downloadFile(document.DocLocation, document.DocName)"
                                                                        class="btn blue-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </b-popover>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="material-list video">
                                        <h4>Videos</h4>
                                        <div class="row">

                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(video, i) in material.videos" :key="i">
                                                        <span v-if="i < 7">
                                                            <a @click.prevent="videoPopup(video.Link)">
                                                                {{ video.VideoName }}
                                                            </a>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(video, i) in material.videos" :key="i">
                                                        <span v-if="i >= 7">
                                                            <a @click.prevent="videoPopup(video.Link)">
                                                                {{ video.VideoName }}
                                                            </a>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import moment from 'moment'
import axios from 'axios';
import VideoPoup from './components/VideoPoup.vue';
// import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "SeminarArchive",
    data() {
        const host = window.location.hostname;
        const port = window.location.port;
        return {
            eventTypes: null,
            nextUrl: null,
            uuidArray: [],
            currmonth: this.getCurrentMonth(),
            host,
            port,
            isLoading: false,
            id: "",
            skill: {
                SkillSetName: ""
            },
            material: {
                videos: {},
                documents: {}
            },
            videoData: {
                videoSrc: ""
            }

        }
    },
    methods: {
        isEventCompleted(id) {
            return this.eventData.some(event => event.id === id);
        },
        getNextUrls() {
            axios
                .get('https://calendly.com/api/v1/users/me/event_types?include=owner', {
                    headers: {
                        'X-TOKEN': 'PMHLBDJBIU6L5QKHN6KQQHZDYZBCBJJF',
                    },
                })
                .then((response) => {
                    console.log(response.data.data);
                    this.nextUrl = response.data.data;
                })
                .catch((error) => {
                    console.error('Error fetching event types:', error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchEventData() {
            userAPI.getcalanderlydata({ uid: this.loginUser.userID }, res => {
                this.eventData = res.data.data
            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        getCurrentMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            return `${year}-${month}`;
        },
        openCalendlyPopup(url) {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: url
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        meating1() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/dc-trainings-coaching-call?utm_source=' + this.userID + '&utm_medium=skills&month=' + this.currmonth
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        meating2() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/dc-trainings-coaching-new-member-call-2?utm_source=' + this.userID + '&utm_medium=skills&month=' + this.currmonth
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        meating3() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/dc-trainings-onboarding-call-3?utm_source=' + this.userID + '&utm_medium=skills&month=' + this.currmonth
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        meating4() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/dc-trainings-onboarding-call-4?utm_source=' + this.userID + '&utm_medium=skills&month=' + this.currmonth
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        coaching() {
            if (window.Calendly) {
                window.Calendly.initPopupWidget({
                    url: 'https://calendly.com/dc-trainings/15min?utm_source=' + this.userID + '&utm_medium=skills&month=' + this.currmonth
                });
            } else {
                console.error('Calendly is not loaded.');
            }
        },
        downloadFile(location, name) {
            try {
                userAPI.downloadPdf({ path: window.location.hostname == '202.141.226.195' ? '8069578_1703609074.pdf' : location }, res => {

                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', name + ".pdf"); // Set the desired file name and extension
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });

            } catch (error) {
                console.error('Error downloading file:', error);
            }
        },
        getMaterialBySkill() {
            this.isLoading = true;
            userAPI.getMaterialBySkill({ skillID: this.id }, res => {
                this.material = res.data.data;
                this.isLoading = false;

            }, err => {
                console.log(err);
                this.isLoading = false;

            })
        },
        videoPopup(link) {
            this.videoData.videoSrc = 'https://player.vimeo.com/video/' + link;
            this.$bvModal.show('videoModel');
        }
    },
    mounted() {
        this.getNextUrls();
        if (this.$route.params.id != undefined || this.$route.params.id != null) {
            if (this.$route.params.data == undefined || this.$route.params.data == null) {
                this.$router.push({ name: 'skill_set' });
            }
            this.skill = this.$route.params.data;
            this.id = this.$route.params.id;
        } else {
            this.$router.push({ name: 'skill_set' });
        }
        this.getMaterialBySkill();
        let user = JSON.parse(localStorage.getItem('userDetails'));
        this.loginUser = user;
        this.fetchEventData();
    },
    components: {
        Sidebar,
        VideoPoup
    }
}
</script>
<style>
.material-list li.completed {
    margin: 16px 0px;
}

.material-list li.completed span {
    background-color: #f1f1f1;
    padding: 8px 4px;
}

.events_schedule {
    color: red;
}
</style>